import { z } from 'zod'

export const uploadedFileObjectSchema = z.object({
  name: z.string(),
  data: z.string(),
  size: z.number(),
  encoding: z.string(),
  tempFilePath: z.string(),
  truncated: z.boolean(),
  mimetype: z.string(),
  md5: z.string(),
})

export const uploadedFileSchema = z.union([
  uploadedFileObjectSchema,
  z.instanceof(File),
  z.null(),
])
